import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/equipoplogs';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async getLogs(params: any) {
    return api.getLogs(params);
  }

  @Action
  async gateAccessRecord(params: any) {
    return api.gateAccessRecord(params)
  }
}
